module.exports = "/images/vendor/trumbowyg/dist/ui/icons.svg?1fc6296bb318d0fb66869259d67cc1d1";